import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import {
  GetQuickBuyResponse,
  GetTisConfigurationOrganisationResponse,
  GetTisConfigurationResponse,
} from '../models/configuration.model';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends BaseApiService {
  getTisConfiguration(): Observable<GetTisConfigurationResponse[]> {
    return this.get<GetTisConfigurationResponse[]>('/configuration/tis');
  }

  getQuickBuy(date: string): Observable<GetQuickBuyResponse> {
    return this.get<GetQuickBuyResponse>(`/configuration/quick-buy/${date}`);
  }

  getTisConfigurationOrganisation(): Observable<GetTisConfigurationOrganisationResponse> {
    return this.get<GetTisConfigurationOrganisationResponse>('/configuration/organisation');
  }
}
